import { cn } from "../../../../../utils/utils";

const PEOPLE_CHIPS = [
  { key: "dateRange", valueOn: "today", valueOff: null, label: "Hôm nay" },
  { key: "unread", valueOn: true, valueOff: false, label: "Chưa đọc" },
  {
    key: "assignedToMe",
    valueOn: true,
    valueOff: false,
    label: "Của tôi",
  },
];

const MESSAGE_CHIPS = [
  { key: "dateRange", valueOn: "today", valueOff: null, label: "Hôm nay" },
  { key: "hasMedia", valueOn: true, valueOff: false, label: "Có ảnh / file" },
];

function Chip({ active, disabled, onClick, children }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={cn(
        "text-xs px-3 py-1 rounded-full border transition-colors",
        active
          ? "bg-blue-500 text-white border-blue-500"
          : "bg-transparent text-gray-600 border-gray-300 hover:border-gray-400",
        disabled && "opacity-50 cursor-not-allowed",
      )}
    >
      {children}
    </button>
  );
}

const FilterChips = ({ activeTab, filters, onChange, disabled }) => {
  const chips = activeTab === "messages" ? MESSAGE_CHIPS : PEOPLE_CHIPS;
  const hasActive = chips.some(
    (c) => filters[c.key] !== c.valueOff && filters[c.key] != null,
  );

  const toggle = (chip) => {
    onChange({
      ...filters,
      [chip.key]:
        filters[chip.key] === chip.valueOn ? chip.valueOff : chip.valueOn,
    });
  };

  const clearAll = () => {
    const next = { ...filters };
    for (const c of [...PEOPLE_CHIPS, ...MESSAGE_CHIPS]) {
      next[c.key] = c.valueOff;
    }
    onChange(next);
  };

  return (
    <div className="flex items-center gap-2 px-4 py-2 border-b overflow-x-auto">
      {chips.map((chip) => (
        <Chip
          key={chip.key + chip.label}
          active={filters[chip.key] === chip.valueOn}
          disabled={disabled}
          onClick={() => toggle(chip)}
        >
          {chip.label}
        </Chip>
      ))}
      {hasActive && !disabled && (
        <button
          type="button"
          onClick={clearAll}
          className="text-xs text-gray-400 hover:text-red-500 ml-auto shrink-0"
        >
          Xóa lọc
        </button>
      )}
    </div>
  );
};

export default FilterChips;
